import { Response, Server } from 'miragejs';

import {
  frameGroupsFileContent,
  framesFileContent,
  mockDataManagementRecord,
  mockFormatSizeResponse,
  mockOverrideResponse,
  mockTagResponse,
  mockVenueTypeResponse,
} from 'mocks/server/data/dataManagement';
import { DATA_MANAGEMENT_DATA_API_URL, FRAME_SERVICE_API_URL } from 'utils/defaults';

const mockDataMap = {
  TAGS: { mockTags: mockTagResponse },
  VENUE_TYPES: { mockVenueTypes: mockVenueTypeResponse },
  FORMAT_SIZES: { mockFormatSizes: mockFormatSizeResponse },
  OVERRIDES: { mockOverrides: mockOverrideResponse },
} as const;

const toCSV = (data: Record<string, unknown>[]) => {
  if (!data.length) return '';

  const headers = Object.keys(data[0]);

  const escapeValue = (val: unknown): string => {
    if (val == null) return '';
    const str = String(val);
    if (str.includes(',') || str.includes('\n')) {
      return `"${str}"`;
    }
    return str;
  };

  const rows = data.map((row) => headers.map((header) => escapeValue(row[header])).join(','));

  return [headers.join(','), ...rows].join('\n');
};

export const dataManagementRoutes = (server: Server) => {
  server.get(DATA_MANAGEMENT_DATA_API_URL, () => {
    return mockDataManagementRecord;
  });

  server.get(`${DATA_MANAGEMENT_DATA_API_URL}/:entity/download`, (schema, request) => {
    const entity = request.params.entity.toUpperCase() as keyof typeof mockDataMap;
    const mockEntityData = mockDataMap[entity];

    const data = Object.values(mockEntityData)[0];

    const csv = toCSV(data as Record<string, unknown>[]);

    return new Response(
      200,
      {
        'Content-Type': 'application/csv',
        'X-Filename': `${entity.toLowerCase()}.csv`,
      },
      csv
    );
  });

  server.put(`${DATA_MANAGEMENT_DATA_API_URL}/:entity/upload`, async (schema, request) => {
    const readFile = async (file: File): Promise<string> =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('There was an error reading the file!'));
        reader.onload = () => resolve(reader.result as string);
        reader.readAsText(file);
      });
    const formData: FormData = request.requestBody as unknown as FormData;
    const uploadFile: File = formData.get('file') as File;
    const fileContents: string = await readFile(uploadFile);
    console.log('Uploaded file contents:', fileContents);
  });

  server.get(FRAME_SERVICE_API_URL, () => {
    return {
      uploadInProgress: false,
    };
  });

  server.get(`${FRAME_SERVICE_API_URL}/frames`, () => {
    return new Response(
      200,
      {
        'Content-Type': 'application/csv',
        'X-Filename': `frames.csv`,
      },
      framesFileContent
    );
  });

  server.get(`${FRAME_SERVICE_API_URL}/frame-groups`, () => {
    return new Response(
      200,
      {
        'Content-Type': 'application/csv',
        'X-Filename': `frame_groups.csv`,
      },
      frameGroupsFileContent
    );
  });
};
